export function IconGmail() {
    return(
        <>
            <svg className="icon" viewBox="0 0 300 225" fill="none" xmlns="http://www.w3.org/2000/svg">

                <g clip-path="url(#clip0_1298_14)">

                    <path d="M20.5094 225H68.3646V109.286L0 57.8572V204.509C0 215.759 9.24933 225 20.5094 225Z" fill="#4285F4"/>

                    <path d="M232.038 225H279.893C291.153 225 300.402 215.759 300.402 204.509V57.8572L232.038 108.884" fill="#34A853"/>

                    <path d="M232.038 20.4912V109.286L300.402 58.259V30.5358C300.402 5.22329 271.448 -9.24099 251.341 6.02687" fill="#FBBC04"/>

                    <path d="M68.3646 109.286V20.4912L150.402 81.9644L232.038 20.4912V109.286L150 170.357" fill="#EA4335"/>

                    <path d="M0 30.5359V57.8573L68.3646 108.884V20.4912L49.0617 6.02692C28.9544 -8.83915 0 5.62514 0 30.5359Z" fill="#C5221F"/>

                </g>

                <defs>

                    <clipPath id="clip0_1298_14">

                        <rect width="300" height="225" fill="white"/>

                    </clipPath>

                </defs>

            </svg>
        </>
    )
}